
import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin';

export default BaseCmsBlock.extend({
  name: 'ContactsBlock',

  data() {
    return {};
  },

  computed: {
    vars() {
      return this.$store.state?.appState?.vars || {};
    },

    config() {
      return this.$store?.state?.appState?.config || {};
    },

    contacts() {
      const { vars } = this;

      const list = [];

      // Офис отдела продаж
      const salesOffice = vars?.['Полный адрес'];
        if (salesOffice) {
          list.push({
            icon: require('~/assets/img/svg/contacts/pin.svg'),
            title: 'Офис отдела продаж:',
            links: [
              {
                message: salesOffice,
                href: '',
              },
            ],
          });
        }

        // Номер телефона отдела продаж
        let salesDepartmentPhoneNumbers = vars?.['Номер телефона отдела продаж'];
        if (salesDepartmentPhoneNumbers) {
          salesDepartmentPhoneNumbers = salesDepartmentPhoneNumbers.split(',');
          const phonesLinks = {
            icon: require('~/assets/img/svg/contacts/phone.svg'),
            title: 'Номер телефона отдела продаж:',
            links: [],
          };

          if (salesDepartmentPhoneNumbers.length > 0) {
            salesDepartmentPhoneNumbers.forEach((phoneNumber) => {
              phonesLinks.links.push({
                message: this.$phoneFormat(phoneNumber),
                href: `tel:+${phoneNumber}`,
              });
            });
          }

          list.push(phonesLinks);
        }

        // Режим работы отдела продаж
        const workingHoursSalesDepartment = vars?.['Режим работы отдела продаж'];
        if (workingHoursSalesDepartment) {
          list.push({
            icon: require('~/assets/img/svg/contacts/clock.svg'),
            title: 'Режим работы отдела продаж:',
            links: [
              {
                message: workingHoursSalesDepartment,
                href: '',
              },
            ],
          });
        }

        // E-mail отдела продаж
        const salesEmail = vars?.['E-mail отдела продаж'];
        if (salesEmail) {
          list.push({
            icon: require('~/assets/img/svg/contacts/email.svg'),
            title: 'E-mail отдела продаж:',
            links: [
              {
                message: salesEmail,
                href: `mailto:${salesEmail}`,
              },
            ],
          });
        }

        // Мы в соц. сетях
        const telegram = vars?.['Телеграмм'];
        const vkontakte = vars?.['Вконтакте'];
        if (telegram || vkontakte) {
          const weInSocials = {
            icon: require('~/assets/img/svg/contacts/socials-icon-dark.svg'),
            title: 'Мы в соц. сетях:',
            links: [],
          }
          if (vkontakte) {
            weInSocials.links.push({
              message: 'ВКонтакте',
              href: `${vkontakte}`,
              target: '_blank'
            })
          }
          if (telegram) {
            weInSocials.links.push({
              message: 'Telegram',
              href: `${telegram}`,
              target: '_blank',
            })
          }
          list.push(weInSocials)
        }


        return list;
    },

    socials() {
      const { config } = this;
      const { vars } = this;

      const list = [];
      if (config.vkontakte) {
        list.push({
          url: config.vkontakte,
          icon: require('~/assets/img/svg/contacts/vk.svg'),
        });
      }
      if (config.telegram) {
        list.push({
          url: config.telegram,
          icon: require('~/assets/img/svg/contacts/telegram.svg'),
        });
      }
      if (config.whatsapp) {
        list.push({
          url: config.whatsapp,
          icon: require('~/assets/img/svg/contacts/whatsapp.svg'),
        });
      }

      return list;
    },
  },
});
